"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const config = {
  validateOn: {
    change: true,
    blur: true
  },
  errorClass: 'invalid-field'
};
var _default = config;
exports.default = _default;